import { joinNumbersWithPlus, jsonifyArray } from '@efdigital/ll-addon-content';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import {
  type AnswerValue,
  type QuizQuestion,
  QuizQuestionType,
} from '@efdigital/ll-addon-data/types/quiz';
import { Type } from '@warp-drive/core/types/symbols';

import marker from './mark-answer.ts';
import {
  generateRandomParagraphs,
  generateRandomWords,
  randomFromArray,
  randomNumberBetween,
  randomNumbersThatSumTo,
  randomValuesFromArray,
} from './random-values.ts';

export function randomAnswer(question: QuizQuestion): string {
  console.log('createRandomAnswerValue', question.title, question.type);
  switch (question.type) {
    case QuizQuestionType.Text:
      return question.text?.multiline
        ? generateRandomParagraphs(3)
        : generateRandomWords(3);
    case QuizQuestionType.Choice: {
      const choices = question.choice?.choices ?? [];
      if (choices.length === 0) {
        return '';
      }
      if (question.choice?.type === 'multiple') {
        return jsonifyArray(
          randomValuesFromArray(choices, 1, choices.length).map(
            (choice) => choice.oid
          )
        );
      } else {
        return randomFromArray(choices).oid;
      }
    }
    case QuizQuestionType.Rank: {
      const options = question.rank?.options ?? [];
      if (options.length === 0) {
        return '';
      }
      return jsonifyArray(
        randomValuesFromArray(
          question.rank!.options,
          Math.min(question.rank!.min || 0, options.length),
          Math.max(question.rank!.max || options.length, options.length)
        ).map((option) => option.oid)
      );
    }
    case QuizQuestionType.Points: {
      const options = question.points?.options ?? [];
      if (options.length === 0) {
        return '';
      }
      return joinNumbersWithPlus(
        randomNumbersThatSumTo(
          options.length,
          randomNumberBetween(
            question.points!.min || 0,
            Math.max(question.points!.min || 0, question.points!.max || 0)
          )
        )
      );
    }
    default:
      return '';
  }
}

export function generateRandomAnswerValues(
  questions: QuizQuestion[],
  existingAnswers: AnswerValue[]
): { values: AnswerValue[]; hasChanges: boolean } {
  let hasChanges = false;
  const values = (questions || []).map((question) => {
    const answer = existingAnswers.find((a) => a.qid == question.qid);
    if (!answer) {
      hasChanges = true;
      return {
        [Type]: DataTypeQuiz.AnswerValue,
        qid: question.qid,
        value: randomAnswer(question),
      };
    } else {
      const marked = marker.markQuestion(question, answer);
      if (!marked || !marked.answered || !marked.correct) {
        hasChanges = true;
        return {
          [Type]: DataTypeQuiz.AnswerValue,
          qid: question.qid,
          value: randomAnswer(question),
        };
      } else {
        return {
          [Type]: DataTypeQuiz.AnswerValue,
          qid: question.qid,
          value: answer.value,
        };
      }
    }
  });

  return { values: values as AnswerValue[], hasChanges };
}
